// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.btnGroup {\n  border-top: 1px solid #9e9e9e;\n  border-left: 1px solid #9e9e9e;\n  border-bottom: 1px solid #9e9e9e;\n  border-top-right-radius:0px !important;\n  border-bottom-right-radius:0px;\n}\n", ""]);
// Exports
module.exports = exports;
